import { cfg } from '../config';

export function load() {
    let link = document.createElement('link');
    link.href = cfg.apiUrlBase + '/static/' + cfg.name + ".css";
    // link.href = cfg.name + ".css";
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.media = 'all';
    document.getElementsByTagName('head')[0].appendChild(link);
}
